<template>
    <ul class="provider-list"
        :class="[selectedProvider && isMobile ? `content-${lowercaseProvider(selectedProvider.name)}` : '']"
    >
        <li :class="[lowercaseProvider(selectedProvider.name), 'even fp-0', {'active': !selectedFilters.is_business}]">
            <a :href="`/${lowercaseProvider(selectedProvider.name)}`" class="provider">
                <img
                    :src="`/images/providers/white/${this.$filters.lowerCase(selectedProvider.name)}.png`"
                    :alt="selectedProvider.name"
                    class="img-fluid me-2"
                />
            </a>
        </li>

        <li :class="[lowercaseProvider(selectedProvider.name), {'active': selectedFilters.is_business}, 'odd fp-1']">
            <a :href="`/zakelijk/${lowercaseProvider(selectedProvider.name)}`" class="provider">
                <img
                    :src="`/images/providers/white/${this.$filters.lowerCase(selectedProvider.name)}.png`"
                    :alt="selectedProvider.name"
                    class="img-fluid me-2"
                />
                <span class="text-uppercase text-sm">
                    Business
                </span>
            </a>
        </li>
    </ul>
</template>

<script>

export default {
    props: {
        providerList: {
            type: Array,
            default: null
        },

        selectedFilters: {
            type: Object,
            default: null
        },

        selectedProvider: {
            type: Object,
            default: null
        },

        allowMinified: {
            type: Boolean,
            default: false
        },

        alternativeOffers: {
            type: Object,
            default: () => []
        },
    },

    data() {
        return {

        }
    },

    methods: {
        lowercaseProvider(provider) {
            return this.$filters.lowerCase(provider)
        },
    }
}
</script>
